import React, { useState, useEffect } from 'react';
import PopupHeader from '../../popupHeader';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../shared/modal/content';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import { updateOrgUnitSearch, selectedShortUrl } from 'actions/organisation';

export default function OrgUnitGeneralInfoModalContainer(props) {
  const dispatch = useDispatch();
  const [ouName, setOUName] = useState('');
  const [ouAbbr, setOUAbbr] = useState('');
  const messageData = useSelector((state) => state.globalMessageReducer.messageData);
  const shortUrls = useSelector((state) => state.organisationsReducer.shortUrls);
  const selectedShortUrlValue = useSelector((state) => state.organisationsReducer.selectedShortUrl);

  const changeOUName = (event) => {
    if (event.target != undefined) setOUName(event.target.value);
    setOUName(event);
  };

  const changeOUAbbr = (event) => {
    if (event.target != undefined) setOUAbbr(event.target.value);
    setOUAbbr(event);
  };

  const orgNameFocusOut = () => {
    let currentOUName = ouName;
    setOUName(currentOUName.trim());
  };
  const changeShortUrl = (i, v) => {
    const urlValue = shortUrls[v.value].text;
    dispatch(selectedShortUrl(urlValue));
  };

  const getPayload = () => {
    return {
      name: ouName,
      abbreviatedName: ouAbbr,
      providerUrl: selectedShortUrlValue,
    };
  };

  const searchInEntityPageByName = (name, cb) => {
    // Set filter to be 1 == org unit
    // When a new OU is created, it will navigate back to Entity Admin page;
    // Filter will be reset to Org and search by the new OU name
    dispatch(updateOrgUnitSearch(name));
    props.changeFilterValue(1);
    if (cb) cb();
  };

  return (
    <Modal show={true} hideWhenClickAway={false} className="shared-waiting-area-settings">
      <PopupHeader title={APP.LANGUAGE.CreateOU.Title} helpLink={APP.EXTERNAL_LINKS.OrgUnit.HelpCreateOrgUnit} />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel" style={{ minHeight: '400px' }}>
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  getPayload={getPayload}
                  messageData={messageData}
                  searchInEntityPageByName={searchInEntityPageByName}
                  dispatch={dispatch}
                />
              </div>
            </div>
            <CenterPanel
              changeOUName={changeOUName}
              shortUrls={shortUrls}
              selectedShortUrlValue={selectedShortUrlValue}
              setOUAbbr={setOUAbbr}
              orgNameFocusOut={orgNameFocusOut}
              changeShortUrl={changeShortUrl}
              dispatch={dispatch}
            />
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <RightPanel
                getPayload={getPayload}
                messageData={messageData}
                searchInEntityPageByName={searchInEntityPageByName}
                dispatch={dispatch}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
